import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "orgCards", "orgPlaceholder"]

  connect() {
    // Listen for organization updates from chat responses
    document.addEventListener('chat:organizations', this.handleOrganizations.bind(this))
  }

  disconnect() {
    document.removeEventListener('chat:organizations', this.handleOrganizations.bind(this))
  }

  toggleMobile() {
    this.sidebarTarget.classList.toggle('open')
    this.overlayTarget.classList.toggle('open')
    this.overlayTarget.classList.toggle('hidden')
  }

  toggleWidget(event) {
    const widget = event.currentTarget.closest('.widget')
    if (widget) {
      widget.classList.toggle('collapsed')
    }
  }

  handleOrganizations(event) {
    const { html, count } = event.detail

    if (html && html.length > 0) {
      // Show organization cards
      if (this.hasOrgCardsTarget && this.hasOrgPlaceholderTarget) {
        this.orgPlaceholderTarget.classList.add('hidden')
        this.orgCardsTarget.classList.remove('hidden')
        this.orgCardsTarget.innerHTML = html.join('')
      }
    }
  }
}
